function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgProcessor = function SvgProcessor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M51.2,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.821-8.533,8.533-8.533s8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C55.634,511.102,53.463,512.001,51.2,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M119.467,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.82-8.533,8.533-8.533c4.713,0,8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C123.901,511.102,121.73,512.001,119.467,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M187.733,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.821-8.533,8.533-8.533c4.713,0,8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C192.168,511.102,189.997,512.001,187.733,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M256,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.821-8.533,8.533-8.533c4.713,0,8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C260.434,511.102,258.263,512.001,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M324.267,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.821-8.533,8.533-8.533s8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C328.701,511.102,326.53,512.001,324.267,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M392.533,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.82-8.533,8.533-8.533s8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C396.968,511.102,394.797,512.001,392.533,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M460.8,512c-2.263,0.001-4.434-0.898-6.035-2.499c-1.6-1.6-2.499-3.771-2.499-6.035V460.8 c0-4.713,3.82-8.533,8.533-8.533s8.533,3.82,8.533,8.533v42.667c0.001,2.263-0.898,4.434-2.499,6.035 C465.234,511.102,463.063,512.001,460.8,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "34.133,413.867 34.133,460.8 68.267,460.8 68.267,413.867 68.267,366.933 34.133,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "102.4,413.867 102.4,460.8 136.533,460.8 136.533,413.867 136.533,366.933 102.4,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "170.667,413.867 170.667,460.8 204.8,460.8 204.8,413.867 204.8,366.933 170.667,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "238.933,413.867 238.933,460.8 273.067,460.8 273.067,413.867 273.067,366.933  238.933,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "307.2,413.867 307.2,460.8 341.333,460.8 341.333,413.867 341.333,366.933 307.2,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "375.467,413.867 375.467,460.8 409.6,460.8 409.6,413.867 409.6,366.933 375.467,366.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "443.733,366.933 443.733,413.867 443.733,460.8 477.867,460.8 477.867,413.867  477.867,366.933  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.133,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.667,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.933,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.2,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.467,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.733,
    y: 392.533,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M460.8,0c2.263-0.001,4.434,0.898,6.035,2.499c1.6,1.6,2.499,3.771,2.499,6.035V51.2 c0,4.713-3.82,8.533-8.533,8.533s-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035 C456.366,0.898,458.537-0.001,460.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M392.533,0c2.263-0.001,4.434,0.898,6.035,2.499c1.6,1.6,2.499,3.771,2.499,6.035V51.2 c0,4.713-3.82,8.533-8.533,8.533S384,55.913,384,51.2V8.533c-0.001-2.263,0.898-4.434,2.499-6.035 C388.099,0.898,390.27-0.001,392.533,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M324.267,0c2.263-0.001,4.434,0.898,6.035,2.499c1.6,1.6,2.499,3.771,2.499,6.035V51.2 c0,4.713-3.82,8.533-8.533,8.533s-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035S322.003-0.001,324.267,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M256,0c2.263-0.001,4.434,0.898,6.035,2.499s2.499,3.771,2.499,6.035V51.2 c0,4.713-3.821,8.533-8.533,8.533c-4.713,0-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035 C251.566,0.898,253.737-0.001,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M187.733,0c2.263-0.001,4.434,0.898,6.035,2.499s2.499,3.771,2.499,6.035V51.2 c0,4.713-3.821,8.533-8.533,8.533c-4.713,0-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035 S185.47-0.001,187.733,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M119.467,0c2.263-0.001,4.434,0.898,6.035,2.499c1.6,1.6,2.499,3.771,2.499,6.035V51.2 c0,4.713-3.821,8.533-8.533,8.533c-4.713,0-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035 S117.203-0.001,119.467,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B19046"
    },
    d: "M51.2,0c2.263-0.001,4.434,0.898,6.035,2.499s2.499,3.771,2.499,6.035V51.2 c0,4.713-3.821,8.533-8.533,8.533s-8.533-3.821-8.533-8.533V8.533c-0.001-2.263,0.898-4.434,2.499-6.035S48.937-0.001,51.2,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "477.867,98.133 477.867,51.2 443.733,51.2 443.733,98.133 443.733,145.067  477.867,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "409.6,98.133 409.6,51.2 375.467,51.2 375.467,98.133 375.467,145.067 409.6,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "341.333,98.133 341.333,51.2 307.2,51.2 307.2,98.133 307.2,145.067 341.333,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "273.067,98.133 273.067,51.2 238.933,51.2 238.933,98.133 238.933,145.067  273.067,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "204.8,98.133 204.8,51.2 170.667,51.2 170.667,98.133 170.667,145.067 204.8,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "136.533,98.133 136.533,51.2 102.4,51.2 102.4,98.133 102.4,145.067 136.533,145.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4C05C"
    },
    points: "68.267,145.067 68.267,98.133 68.267,51.2 34.133,51.2 34.133,98.133 34.133,145.067  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 443.733,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.467,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.2,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.933,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.667,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.133,
    y: 85.333,
    style: {
      fill: "#B19046"
    },
    width: 34.133,
    height: 34.133
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#35495E"
    },
    d: "M503.467,136.533v238.933c0,9.426-7.641,17.067-17.067,17.067H25.6 c-9.426,0-17.067-7.641-17.067-17.067V281.6c14.138,0,25.6-11.461,25.6-25.6c0-14.138-11.462-25.6-25.6-25.6v-93.867 c0-9.426,7.641-17.067,17.067-17.067h460.8C495.826,119.467,503.467,127.108,503.467,136.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57E25"
    },
    d: "M324.181,307.2c-16.06,21.509-41.338,34.164-68.181,34.133V307.2H324.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29C1F"
    },
    d: "M256,307.2v34.133c-26.843,0.031-52.122-12.624-68.181-34.133H256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3E50"
    },
    d: "M341.333,256c0.016,18.48-6.007,36.459-17.152,51.2H187.819c-22.869-30.303-22.869-72.097,0-102.4 h136.363C335.327,219.541,341.35,237.52,341.333,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29C1F"
    },
    d: "M256,170.667V204.8h-68.181C203.878,183.291,229.157,170.636,256,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57E25"
    },
    d: "M324.181,204.8H256v-34.133C282.843,170.636,308.122,183.291,324.181,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41767F"
    },
    d: "M238.933,238.933h34.133c4.713,0,8.533,3.821,8.533,8.533v17.067c0,4.713-3.82,8.533-8.533,8.533 h-34.133c-4.713,0-8.533-3.82-8.533-8.533v-17.067C230.4,242.754,234.221,238.933,238.933,238.933z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5C6C"
    },
    d: "M110.933,162.133H42.667c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h68.267 c4.713,0,8.533,3.82,8.533,8.533S115.646,162.133,110.933,162.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5C6C"
    },
    d: "M153.6,162.133h-8.533c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h8.533 c4.713,0,8.533,3.82,8.533,8.533S158.313,162.133,153.6,162.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5C6C"
    },
    d: "M469.333,366.933h-68.267c-4.713,0-8.533-3.82-8.533-8.533s3.82-8.533,8.533-8.533h68.267 c4.713,0,8.533,3.82,8.533,8.533S474.046,366.933,469.333,366.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5C6C"
    },
    d: "M366.933,366.933H358.4c-4.713,0-8.533-3.82-8.533-8.533s3.82-8.533,8.533-8.533h8.533 c4.713,0,8.533,3.82,8.533,8.533S371.646,366.933,366.933,366.933z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcessor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/processor.8f5c1d0a.svg";
export { ForwardRef as ReactComponent };